export default __webpack_public_path__ + "static/media/Mask Group.c8573f1e.png";